import { tenantRegistry } from "./tenantRegistry";

export function useTenant() {
  const hospital = JSON.parse(localStorage.getItem("hospital") || "null");

  if (!hospital) {
    throw new Error("Missing/Unknown Hospital");
  }

  const hospitalName = hospital.name.toLowerCase();
  const tenant = tenantRegistry[hospitalName] ?? tenantRegistry.default;

  return {
    hospital,
    hospitalId: hospital.id,
    login: tenant.login,
    panel: tenant.panel,
    gisterSteps: tenant.gisterSteps,
    gister: tenant.gister
  };
}
